import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./index.css";

export default function Congratulations( {guestData}) {

  const imgCDN = process.env.REACT_APP_CDN_LINK + "ussaic/"
    return (
        <Row>
            <Col sm={12} className="text-center">
            {/* <p className="presentQRCodeText text-center">
            This Digital Art entitles you and your guest to enter the Angel Token Launch  - The Party Event.

                            </p> */}
                {/* <p className="congratsText">
                    Congratulations
                </p> */}
                <img src={imgCDN +"congrats-stars.webp"} alt="Congratulations" className="congrats-img"/>
                {/* {guestData && guestData.section && guestData.section === "VIP" && (
                  <p
                    className="youare"
                  >
                    You are our VIP guest
                  </p>
                )} */}
            </Col>
        </Row>
    );
}
